import React, { useEffect, useState } from "react";
import { Flex, Menu, MenuButton, MenuItem, MenuList, Text } from "@chakra-ui/react";
import { colours } from "utils/themeUtils";
import { Icon } from "@familyzone/component-library";

interface studentSortOrderProps {
	studentSortOrder: string;
	onSortOrderChange: (sortOrder: string) => void;
}

export function StudentSortOrder({ studentSortOrder, onSortOrderChange }: studentSortOrderProps): JSX.Element {
	const [sortText, setSortText] = useState(studentSortOrder === "lastNameAscending" ? "Last Name A-Z" : "First Name A-Z");

	useEffect(() => {
		setSortText(studentSortOrder === "lastNameAscending" ? "Last Name A-Z" : "First Name A-Z");
	}, [studentSortOrder]);

	const sortByFirstName = () => {
		setSortText("First Name A-Z");
		onSortOrderChange("firstNameAscending");
	};

	const sortByLastName = () => {
		setSortText("Last Name A-Z");
		onSortOrderChange("lastNameAscending");
	};

	return (
		<Flex>
			<Menu>
				<MenuButton>
					<Flex
						height={"26px"}
						alignItems={"center"}
						px={10}
						gap={6}
						color={colours.blueGray[600]}
						border={`1px solid ${colours.blueGray[300]}`}
						borderRadius={"4px"}
						cursor={"pointer"}
					>
						<Text fontFamily="Roboto" fontWeight={500}>
							Sort by:
						</Text>
						<Text fontFamily="Roboto">{sortText}</Text>
						<Icon icon="fa-chevron-down" />
					</Flex>
				</MenuButton>
				<MenuList zIndex={10} mt="-5px" background={"transparent"} border={`1px solid ${colours.blueGray[300]}`} borderRadius={"4px"}>
					<MenuItem
						w={studentSortOrder === "lastNameAscending" ? "187px" : "188px"}
						px={10}
						height={"26px"}
						color={colours.blueGray[600]}
						_hover={{ background: "transparent" }}
						onClick={() => {
							studentSortOrder === "lastNameAscending" ? sortByFirstName() : sortByLastName();
						}}
					>
						<Text fontFamily="Roboto">{studentSortOrder === "lastNameAscending" ? "First Name A-Z" : "Last Name A-Z"}</Text>
					</MenuItem>
				</MenuList>
			</Menu>
		</Flex>
	);
}
